
const coreHelper = {
    createGenericResponseError(msg) {
        return { success: false, message: msg || "An error occured while processing the request" }
    }
}

export default coreHelper;